<template>
  <q-item clickable v-close-popup>
    <q-item-section avatar>
      <q-icon color="primary" :name="tabOutlineUpload" size="xs" @click="handleFilePick(fileModel)"></q-icon>
      <q-btn
        v-if="fileModel"
        round
        text-color="black"
        flat
        :icon="tabOutlineUpload"
      />
    </q-item-section>
    <q-item-section class="no-wrap">
      <q-file
        v-model="fileModel"
        max-file-size="51000000"
        label-color="primary"
        borderless
        dense
        label="Upload Audio File"
        accept=".wav,.mp3,.aac,.m4a"
        @input="(e) => handleFilePick(e.target.files[0])"
    ></q-file>
    </q-item-section>
  </q-item>
</template>

<script>
import { defineComponent } from 'vue';
import { Timestamp } from '@/firebaseConfig.js';
import uuid from 'uuid-v4';

import { tabOutlinePaperclip, tabOutlineUpload } from 'quasar-extras-svg-icons/tabler-icons-v3';
import { convertBlobToBase64, SendError } from '@/helpers';
import UploadRecordingModal from '@/components/modals/UploadRecordingModal.vue';
import { mapState } from 'vuex';

export default defineComponent({
  data() {
    return {
      fileModel: null,
      tabOutlinePaperclip,
      tabOutlineUpload,
    };
  },
  computed: {
    ...mapState(['currentOrganizationId']),
  },
  methods: {
    async handleFilePick(file) {
      try {
        const { seconds, nanoseconds } = Timestamp.now();
        const duration = await this.computeDuration(file);
        if (duration < 5000) {
          return SendError('Recording too short');
        }
        if (duration > 3 * 60 * 60 * 1000) {  
          return SendError('Recording cannot be longer than 3 hours');
        }
        const recording = {
          status: 'local',
          id: uuid(),
          name: `${file.name}`,
          createdAt: {
            seconds,
            nanoseconds,
          },
          organizationId: this.currentOrganizationId,
          audioURL: await convertBlobToBase64(file),
          mimeType: file.type,
          duration,
        };

        await this.$store.dispatch('recs/local/addLocalRecording',recording);
        this.$q.dialog({
          component: UploadRecordingModal,
          componentProps: {
            localRecordingId: recording.id,
            localRecordingName: recording.name,
          },
        });
      } catch (error) {
        SendError('Invalid file');
      } finally {
        this.fileModel = null;
      }
    },
    computeDuration(file) {
      return new Promise((resolve, reject) => {
        const audio = new Audio();
        const objectURL = URL.createObjectURL(file);
        audio.src = objectURL;

        // Use the loadedmetadata event
        audio.addEventListener('loadedmetadata', () => {
          URL.revokeObjectURL(objectURL);
          resolve(audio.duration * 1000); // duration in milliseconds
        });

        // Error handling
        audio.addEventListener('error', () => {
          URL.revokeObjectURL(objectURL);
          reject(new Error('Failed to load audio metadata.'));
        });
      });
    },
  },
});
</script>
